'use strict';
angular.module('more.ui.form').directive('bindJavascript', function ($sce) {

    return {
        restrict: 'A',
        scope: {
            bindJavascript: '='
        },
        transclude: true,
        // Bind the sanitized, trusted HTML
        template: '<span ng-bind-html="_trustedHtml"></span>',
        link: function (scope) {
            // Sanitize incoming HTML with DOMPurify, then trust as HTML for Angular
            function sanitizeAndTrust(html) {
                var raw = html || '';
                // Prefer DOMPurify if available; otherwise, render nothing for safety
                if (typeof DOMPurify !== 'undefined' && DOMPurify && typeof DOMPurify.sanitize === 'function') {
                    try {
                        var sanitized = DOMPurify.sanitize(raw, {
                            USE_PROFILES: {html: true},
                            ADD_TAGS: ['iframe'],
                            FORBID_TAGS: ['style'],
                        });
                        return $sce.trustAsHtml(sanitized);
                    } catch (e) {
                        // If sanitization fails, fall back to empty string
                        return $sce.trustAsHtml('');
                    }
                }
                // If DOMPurify is not available, render nothing
                return $sce.trustAsHtml('');
            }

            scope.$watch('bindJavascript', function (newVal) {
                scope._trustedHtml = sanitizeAndTrust(newVal);
            });
        }
    };

});
